import { Column, Row } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'

const HeroStat = ({ value, label }: { value: string; label: string }) => (
  <Column className="flex-1 gap-1 px-0 py-4 md:px-6 md:py-6 md:first:pl-0">
    <span className="serif text-2xl italic !leading-none text-foreground whitespace-nowrap md:text-[32px]">
      {value}
    </span>
    <span className="text-xs font-normal uppercase tracking-[0.14em] text-muted-foreground">
      {label}
    </span>
  </Column>
)

export const OurProductsHero = () => {
  const { t, locale } = useLocalization()

  return (
    <Column className="gap-10 pt-10 md:pt-16">
      <Row className="items-center gap-4">
        <span className="h-px w-10 bg-foreground/40" aria-hidden />
        <span className="text-xs font-normal uppercase tracking-[0.22em] text-muted-foreground">
          {t('Our products — curated for teams', 'Våra produkter — utvalt för team')}
        </span>
      </Row>

      <div className="grid items-end gap-8 md:grid-cols-12 md:gap-12">
        <h1 className="col-span-7 max-w-[14ch] text-[44px] font-medium !leading-[1.02] tracking-[-0.02em] md:text-[76px]">
          {locale === 'sv' ? (
            <>
              Merch värd{' '}
              <span className="serif italic font-normal [font-size:inherit] [line-height:inherit] tracking-normal">
                att behålla.
              </span>
            </>
          ) : (
            <>
              Merch worth{' '}
              <span className="serif italic font-normal [font-size:inherit] [line-height:inherit] tracking-normal">
                keeping.
              </span>
            </>
          )}
        </h1>

        <Column className="col-span-5 gap-4 pb-2">
          <p className="text-base font-normal leading-relaxed text-foreground/80">
            {t(
              'We hand-pick merchandise that looks great, lasts long, and ships on time — from premium apparel and drinkware to event kits and office essentials.',
              'Vi handplockar profilprodukter som ser bra ut, håller länge och levereras i tid — från premiumkläder och muggar till eventkit och kontorsmaterial.'
            )}
          </p>
          <p className="text-sm font-normal leading-relaxed text-muted-foreground">
            {t(
              'Every item is vetted for print quality, reliable suppliers, and real-world use. Fewer surprises, consistent branding, one partner.',
              'Varje artikel är granskad för tryckkvalitet, pålitliga leverantörer och vardagsanvändning. Färre överraskningar, enhetligt varumärke, en partner.'
            )}
          </p>
        </Column>
      </div>

      <Column className="divide-y divide-[hsl(220,13%,84%)] border-y border-[hsl(220,13%,84%)] md:!flex-row md:divide-x md:divide-y-0">
        <HeroStat
          value="10 000+"
          label={t('products in the catalog', 'produkter i katalogen')}
        />
        <HeroStat
          value="100%"
          label={t('vetted print quality', 'granskad tryckkvalitet')}
        />
        <HeroStat
          value={t('One', 'En')}
          label={t('partner, one invoice', 'partner, en faktura')}
        />
      </Column>
    </Column>
  )
}
